import React from 'react'
import project from '../../project'
// import BreachCodes from './BreachCodes'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import { Tracking219 } from './Tracking'
// import { ajaxSetup } from 'jquery'
import axios from 'axios';

import "../assets/styles/home.scss"

const apiURL_storage = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/AFLeliteJuniors2025/prod/AFLeliteJuniors2025.json'
// ajaxSetup({ cache: true })

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstInteraction: false,
      breach: null,
      SubscriptionUrl: '',
      // siteDomain: '',
      siteDomain: window.location.hostname.replace('www.','').replace('.com.au',''), //  codesports
      siteCode: '',
      isMobApp: false,
      age: null,
      data: undefined,
      dataU17: undefined,
      dataU18: undefined
    }

    // this.siteCode = this.siteCode.bind(this)
    // this.checkBreach = this.checkBreach.bind(this)
    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
    const whichAge = appContainer.getAttribute('data-age')
    // console.log('whichAge', whichAge)
    thisState.state.age = whichAge
    
  }

  componentDidMount () {
    // this.checkBreach()
    this.loadData()
  }

  loadData () {

    axios.get(apiURL_storage)
    .then((response) => {
      let titlesRemoved = response.data.values
      titlesRemoved.shift()

      this.setState({
        data: titlesRemoved
      }, function () {
        this.processData()
      });


    })
    .catch((err) => {
      console.log('err', err)
    })
  }

  processData () {
    
    const data = this.state.data
    const u17Data = data.filter( card => card[1] == 'u17' )
    const u18Data = data.filter( card => card[1] == 'u18' )

    this.setState({
      dataU17: u17Data,
      dataU18: u18Data
    }, function () {
      if ( this.state.breach === true ) {
        // this.dataSlash()
      }
    });

  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  /*siteCode (siteHostname) {
    console.log('siteHostname', siteHostname)
    let siteCode, siteDomain
    switch (siteHostname) {
      
      case 'www.adelaidenow.com.au' :
        siteCode = 'adv'
        siteDomain = 'adelaidenow'
        break
      
      case 'www.cairnspost.com.au' :
        siteCode = 'cp'
        siteDomain = 'cairnspost'
        break

      case 'www.codesportssit.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case 'www.codesports.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break

      case 'www.codesportsuat.com.au' :
        siteCode = 'cs'
        siteDomain = 'codesports'
        break
      
      case  'www.couriermail.com.au' :
        siteCode = 'cm'
        siteDomain = 'couriermail'
        break

      case  'www.heraldsun.com.au' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
      
      case  'www.geelongadvertiser.com.au' :
        siteCode = 'ga'
        siteDomain = 'geelongadvertiser'
        break
      
      case  'www.goldcoastbulletin.com.au' :
        siteCode = 'gcb'
        siteDomain = 'goldcoastbulletin'
        break

      case  'www.ntnews.com.au' :
        siteCode = 'ntn'
        siteDomain = 'ntnews'
        break
      
      case  'www.thechronicle.com.au' :
        siteCode = 'twc'
        siteDomain = 'thechronicle'
        break

      case  'www.themercury.com.au' :
        siteCode = 'merc'
        siteDomain = 'themercury'
        break
      
      case  'www.townsvillebulletin.com.au' :
        siteCode = 'tb'
        siteDomain = 'townsvillebulletin'
        break
      
      case  'www.weeklytimesnow.com.au' :
        siteCode = 'wtn'
        siteDomain = 'weeklytimesnow'
        break
      
      case  'www.dailytelegraph.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case  'www.dailytelegraphsit.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case  'www.dailytelegraphuat.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case 'localhost' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break
    }
    this.setState({
      siteCode: siteCode,
      siteDomain: siteDomain
    })

    return siteCode

  }*/

  /*goLogin () {
    const loginButton = document.querySelectorAll('.header_log-in, .tgc-auth-buttons_login') // Mastheads, Codesport, Regionals
    // console.log('loginButton', loginButton)
    loginButton[0].click()
  }*/

  /*checkBreach () {

    // const whatSite = this.siteCode(window.location.hostname)
    // console.log('site', whatSite)
    
    // check for both new and old app
    // const isMobileApp = document.getElementById('screenkit--embed-container') || window.DNA_APP_ENV;

    const isDeskMobAttribute = document.body.getAttribute('data-device')
    // console.log('isDeskMobAttribute', isDeskMobAttribute)
    const isMobileApp = ( isDeskMobAttribute === 'mobile' || isDeskMobAttribute === 'desktop' ) ? false : true
    // console.log('isMobileApp', isMobileApp)

    // console.log('isMobileApp', isMobileApp);
    // console.log('window.utag_data', window.utag_data);
        
    if (isMobileApp) {
      this.state.breach = false
      this.state.isMobApp = true
      this.loadData()

    } else if (window.utag_data) {
      if( (typeof window.utag_data.net_platform !== "undefined") && (typeof window.utag_data.pc_memtype !== "undefined") ) {
          const currentDomain = window.location.hostname
          const currentUrl = window.location.href
          const netsite = this.siteCode(window.location.hostname)
          const netplatform = window.utag_data.net_platform
          const breachSourceCode = BreachCodes[netsite][netplatform]
          const subUrl = 'https://'
            + currentDomain
            + '/subscribe/news/1/'
            + '?sourceCode=' + breachSourceCode
            + '&dest=' + encodeURIComponent(currentUrl)
            + '&memtype=anonymous&mode=premium'
            + '&v21=dynamic-hot-control-score&V21spcbehaviour=append'

          this.state.SubscriptionUrl = subUrl
          this.state.breach = ( utag_data && utag_data.pc_memtype == "subscriber" ) ? false : true;
          this.loadData()

      }
      else {
          setTimeout(this.checkBreach, 250);
      }
    }
    else {
      setTimeout(this.checkBreach, 250);
    }
    
  }*/

  /*dataSlash () {
    console.log('this.state.data', this.state.data)
    
    let slashedDataU17 = []
    let slashedDataU18 = []

    this.state.dataU17.forEach(function(p, index) {
      if (index < 3 ) {
        slashedDataU17.push(p)
      }
    })

    this.state.dataU18.forEach(function(p, index) {
      if (index < 3 ) {
        slashedDataU18.push(p)
      }
    })

    // let slashedData = this.state.data.slice(0, 20)

    this.setState({
      dataU17: slashedDataU17,
      dataU18: slashedDataU18
    })
  }
  */

  /*goSubscribe () {
    window.location.assign(this.state.SubscriptionUrl);
  }*/

  render() {
    const listU17 = (typeof this.state.dataU17 !== 'undefined') ? this.state.dataU17.map((item) => {
      if (typeof this.state.dataU17 !== 'undefined') {
        return (
          <div key={item[0]} className={`nnd-row nnd-${(item[0]%2 ? 'odd':'even')}`} >
            <div className="nnd-col-img">
            
              {item[2] !== ''
              ?
                <picture>
                  <source srcSet={require(`../assets/images/${item[2]}.jpg`)} media="(min-width: 768px)" />
                  <img loading="lazy" srcSet={require(`../assets/images/${item[2]}.jpg`)} src={require(`../assets/images/${item[2]}.jpg`)} />
                </picture>
              :
                ''
              }
            

            </div>
            <div className="nnd-col-text">
              <h3>{ item[3] }</h3>
              <p className="nnd-club"><span>Club: </span>{ item[4] }</p>
              <p className="nnd-height"><span>Height: </span>{ item[5] }</p>
              <p className="nnd-dob"><span>DOB: </span>{ item[7] }</p>
              <p className="nnd-desc">{ item[8] }</p>
            </div>
          </div>
        )
      }
    }) : ''

    const listU18 = (typeof this.state.dataU18 !== 'undefined') ? this.state.dataU18.map((item) => {
      if (typeof this.state.dataU18 !== 'undefined') {
        return (
          <div key={item[0]} className={`nnd-row nnd-${(item[0]%2 ? 'odd':'even')}`} >
            <div className="nnd-col-img">
            {item[2] !== ''
              ?
              <picture>
                <source srcSet={require(`../assets/images/${item[2]}.jpg`)} media="(min-width: 768px)" />
                <img alt={item[3]} loading="lazy" srcSet={require(`../assets/images/${item[2]}.jpg`)} src={require(`../assets/images/${item[2]}.jpg`)} />
              </picture>
              :
              ''
            }
            </div>
            <div className="nnd-col-text">
              <h3>{ item[3] }</h3>
              <p className="nnd-club"><span>Club: </span>{ item[4] }</p>
              <p className="nnd-height"><span>Height: </span>{ item[5] }</p>
              <p className="nnd-dob"><span>DOB: </span>{ item[6] }</p>
              <p className="nnd-desc">{ item[7] }</p>
            </div>
          </div>
        )
      }
    }) : ''

    // const isBreached = this.state.breach
    const siteDomain = this.state.siteDomain
    // const title = (this.state.age == 'U17') ? "AFL Draft Special: The top 25 under-17 prospects from across Australia" : "AFL Draft Special: The top 78 draft prospects from across Australia"

    return (
      <div id="nnd-container" className={`${siteDomain ? "nnd-" + siteDomain : ""}`}>

        <div className="nnd-heading-logo">
          {this.state.age == 'U17'
              ? 
              <img alt="Top 25 AFL Draft U/17" className="nnd-heading-u17" src={require('../assets/images/top-25-logo.png')} />
              : 
              <img alt="Top 78 AFL Draft U/18" src={require('../assets/images/top-75-logo.png')} />
          }
        </div>
        
        {this.state.age == 'U17'
            ? 
            <div className="nnd-cont-main">
              {listU17} 
            </div>
            : 
            <div className="nnd-cont-main">
              {listU18} 
            </div>
        }

        {/*isBreached === true
          ? 
          <div id="nnd-breach-overlay" className="nnd-breach-overlay">
              {this.state.siteDomain !== 'codesports'
                ?
                <div className="nnd-breach-message-metro">
                  <p className="nnd-bm1"><span>There's more to this story.</span></p>
                  <p className="nnd-bm1"><span>Subscribe to unlock all the players</span></p>
                  <p className="nnd-bm2">$1 a week for the first 12 weeks.<br />(min cost $4)</p>
                  <a className="nnd-breachLink" onClick={(e) => { this.goSubscribe(e) }}>Subscribe</a>
                  <p className="nnd-bm3"><a onClick={(e) => { this.goLogin(e); e.preventDefault() }}>Log in</a> | T&Cs apply</p>
                </div>
                :
                <div className="nnd-breach-message-cs">
                  <div className="nnd-logo"></div>
                  <p className="nnd-bm1">Read the full story.</p>
                  <p className="nnd-bm2">Try the ultimate sports subscription, only <b>$1 for the first 2 months</b>, including:</p>
                  <ul className="nnd-bm3">
                    <li>Full access to analysis, breaking news, live scores and stats covering a range of sports from AFL, NRL, netball and cricket, to NBA, NFL and more</li>
                    <li>Award-winning writers from around the globe with exclusive insights from pro athletes</li>
                    <li>Complimentary access to SuperCoach Plus</li>
                    <li>No commitment, cancel anytime</li>
                  </ul>
                  <a className="nnd-breachLink" onClick={(e) => { this.goSubscribe(e) }}>Best offers</a>
                  <p className="nnd-bm4"><a onClick={(e) => { this.goLogin(e); e.preventDefault() }}>Log in</a> |  <a href="https://www.codesports.com.au/more-information/terms-and-conditions">T&Cs apply</a></p>
                </div>
              }
          </div>
          : ''
        */}

      </div>
      
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js